var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ValidationObserver', {
    ref: "observer"
  }, [_c('ValidationProvider', {
    attrs: {
      "rules": "required"
    }
  }, [_c('TextareaButton', {
    attrs: {
      "placeholder": _vm.placeholder,
      "height": _vm.height,
      "border-radius": _vm.borderRadius
    },
    on: {
      "click": _vm.onClick,
      "update:model-value": function ($event) {
        _vm.data.text = $event;
      }
    },
    model: {
      value: _vm.data.text,
      callback: function ($$v) {
        _vm.$set(_vm.data, "text", $$v);
      },
      expression: "data.text"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }